import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.tzDisplayElement = document.getElementById('time-zone-display')?.parentElement;
    this.tzFormElement = document.getElementById('time-zone-form');
  }

  editTz() {
    this.tzDisplayElement.style.display = 'none';
    this.tzFormElement.style.display = 'inline';
  }

  updateTz(event) {
    event.preventDefault();

    const formData = new FormData(this.tzFormElement);

    fetch(this.tzFormElement.action, {
      method: 'PATCH',
      headers: {
        'X-CSRF-Token': document.querySelector("meta[name='csrf-token']").content,
        'Accept': 'application/json',
      },
      body: formData,
    })
      .then(response => response.json())
      .then(data => {
        if (data.time_zone) {
          document.getElementById('time-zone-display').textContent = data.time_zone;
          this.cancelEditTz();
        }
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }

  cancelEditTz() {
    this.tzDisplayElement.style.display = 'block';
    this.tzFormElement.style.display = 'none';
  }

  toggleDmographicFields() {
    $("#demographic-field-form").toggleClass("d-none");
  }

  removeDemographicField(event) {
    $(event.target).closest(".demographic-field").remove();
  }

}
